<div #chartContainer class="w-full h-full relative chart-container-class" [style.min-height.px]="minHeight"></div>
